module.exports = __webpack_public_path__ + "img/onboarding-decoration-3.d27547fe.svg";